import React, { useState, useCallback } from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '100%'
};

function ClientMapComponent({ center, markers }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  const [selectedMarker, setSelectedMarker] = useState(null);

  const onLoad = useCallback(map => {
    map.setZoom(8);
    map.setCenter(center);
  }, [center]);

  const onUnmount = useCallback(() => {}, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={8}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      {markers.map((marker) => (
        <Marker
          key={marker.id}
          position={{ lat: marker.lat, lng: marker.lng }}
          onClick={() => setSelectedMarker(marker)}
        />
      ))}

      {selectedMarker && (
        <InfoWindow
          position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
          onCloseClick={() => setSelectedMarker(null)}
          options={{
            pixelOffset: new window.google.maps.Size(0, -30)
          }}
        >
          <div style={{
            maxWidth: '240px',
            fontFamily: 'Arial, sans-serif',
            padding: '10px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
          }}>
            <h4 style={{
              margin: '0 0 6px',
              fontSize: '16px',
              color: '#333'
            }}>{selectedMarker.name}</h4>

            <p style={{ margin: '0 0 4px', fontSize: '14px', color: '#666' }}>
              {selectedMarker.address}
            </p>
            <p style={{ margin: '0 0 10px', fontSize: '14px', color: '#666' }}>
              {selectedMarker.city}, {selectedMarker.state}
            </p>

            <div>
              <strong style={{ fontSize: '14px', color: '#333' }}>Services:</strong>
              <ul style={{
                marginTop: '6px',
                paddingLeft: '18px',
                fontSize: '14px',
                color: '#007bff'
              }}>
                {selectedMarker.services?.map((service) => (
                  <li key={service.id} style={{ marginBottom: '4px' }}>
                    <a
                      href={`/client-service/details/${service.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#007bff', textDecoration: 'none' }}
                      onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
                      onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
                    >
                      {service.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </InfoWindow>

      )}
    </GoogleMap>
  ) : <></>;
}

export default React.memo(ClientMapComponent);
